import React, { useState } from 'react'
import { useTrans, useListing } from 'hooks'
import { CategoriaType, PaginaType } from 'utils/types'
import { PAGE_SIZE, TIPO_1 } from 'utils/settings'
import { Reload } from 'components/atoms/Icons'
import { WContainer, Button, Label, WImage } from 'components/atoms'
import { ArticoloCard, LinkBox } from 'components/molecules'
import { Page, RoundHead } from 'components/organisms'
import styles from './ListingArticoliTemplate.module.sass'

interface Props {
  pagina: PaginaType
  categoria: CategoriaType
  mainArticolo?: boolean
}

const ListingArticoliTemplate = (props: Props) => {
  const { pagina, categoria = { articoli: [] }, mainArticolo = false } = props

  const [articoli, setArticoli] = useState(categoria.articoli)
  const [page, setPage] = useState(1)

  const pageSize = PAGE_SIZE[categoria.tipo]

  const { getUniqueFilters, getAttributi, toggleFilter, paginatedItems } = useListing(
    categoria.articoli,
    setArticoli,
    pageSize
  )

  const t = useTrans()

  const loadMore = () => {
    setPage(page + 1)
  }

  const hasOtherPages = articoli.length / pageSize >= page

  const icon = mainArticolo ? (
    <WImage
      src={categoria.mainImage}
      maxHeight={90}
      maxWidth={90}
      priority
      loading="eager"
      alt={categoria.titolo}
      title={categoria.titolo}
      layout="intrinsic"
    />
  ) : null

  return (
    <Page pagina={pagina} item={categoria}>
      <div className={styles.listingArticoliTemplate}>
        <RoundHead
          breadcrumbs={pagina.breadcrumbs}
          title={categoria.titolo}
          description={categoria.descrizione}
          icon={icon}
          className={styles.roundHead}
          size="lg"
        />
        {mainArticolo && categoria.linkBox && (
          <WContainer variant="xs">
            <LinkBox item={categoria.linkBox} className={styles.linkBox} variant="light" />
          </WContainer>
        )}
        <WContainer>
          {getAttributi(getUniqueFilters()).length > 1 && (
            <>
              <h5 className={styles.filtriTitle}>{t('Filtra per i temi più ricercati')}</h5>
              <div className={styles.filtri}>
                {getAttributi(getUniqueFilters()).map((a) => (
                  <Label
                    label={a.nome}
                    onClick={() => toggleFilter(a)}
                    removable={a.selected}
                    color={a.selected ? 'blue' : 'light-blue'}
                    shadow
                    bordered
                    key={a.pk}
                  />
                ))}
              </div>
            </>
          )}
          <div className={`${styles.list} ${mainArticolo ? styles['list--mainArticolo'] : ''}`}>
            {[...Array(page).keys()].map((currentPage) =>
              paginatedItems(articoli, currentPage + 1).map((item, index) => (
                <div className={styles.item} key={item.pk}>
                  <ArticoloCard
                    articolo={item}
                    size={mainArticolo && index === 0 && currentPage === 0 ? 'big' : 'default'}
                  />
                </div>
              ))
            )}
          </div>
          {hasOtherPages && (
            <div className={styles.more}>
              <Button
                label={t('Carica altri')}
                icon={<Reload />}
                iconPos="right"
                variant="ghost"
                className={styles.moreButton}
                onClick={loadMore}
              />
            </div>
          )}
        </WContainer>
      </div>
    </Page>
  )
}

export default ListingArticoliTemplate
